<template>
    <Row type="none" class="bg-white rounded shadow min-h-screen">

        <b-modal id="pay-modal" hide-footer>
            <!-- Modal body -->
            <div class="modal-body">
                {{ $t('payWarning') }}
            </div>
            <!-- Modal footer -->
            <div class="modal-footer">
                <button type="button" class="btn btn-danger" data-dismiss="modal" @click="payDebts">{{
                        $t('yes')
                    }}
                </button>
                <button type="button" class="btn btn-primary" data-dismiss="modal" @click="$bvModal.hide('pay-modal')">
                    {{ $t('no') }}
                </button>
            </div>
        </b-modal>
        <b-modal size="xl" id="my-modal-data" :title="$t('debt')" ok-only>
            <table class="table mt-3">
                <thead>
                <tr>
                    <th scope="col" class="d-none d-lg-table-cell">{{ $t('printView.receipt') }}</th>
                    <th scope="col">{{ $t('printView.totalSum') }}</th>
                    <th scope="col">{{ $t('date') }}</th>
                    <th scope="col" class="d-none d-lg-table-cell">{{ $t('additionalInformation') }}</th>
                    <th scope="col">{{ $t('actions') }}</th>
                </tr>
                </thead>
                <tbody
                    v-for="item in getDebt.sales"
                    :key="item.id"
                >
                <tr style="cursor: pointer;">
                    <td class="d-none d-lg-table-cell" @click="goToDetails(item.id)">{{ item.id }}</td>
                    <td @click="goToDetails(item.id)">{{ showCurrencyById(item.currency.id, item.totalPrice) }}</td>
                    <td @click="goToDetails(item.id)">
                        {{ dateTimeFormat(item.createdAt, false) }}
                    </td>
                    <td class="d-none d-md-table-cell" style="color: #3EEAC1" @click="goToDetails(item.id)">
                        {{ textSplice(item.description) }}
                    </td>
                    <td>
                        <span
                            v-if="saleId !== item.id"
                            @click="saleId = item.id"

                            style="background-color: #2C0FDE; color: #FFFFFF; border-radius: 3px; padding: 4px 7px 2px 7px"
                        >&#9660;</span>
                        <span
                            v-else @click="saleId = null"

                            style="background-color: #2C0FDE; color: #FFFFFF; border-radius: 3px; padding: 2px 7px 4px 7px"
                        >&#9650;</span>
                    </td>
                </tr>
                <tr v-if="saleId === item.id">
                    <td colspan="7">
                        <Row
                            type="form-row"
                            class="col-sm-10 m-0 pt-2 my-2 justify-content-end"
                        >
                            <table class="table pr-10 pl-10" style="box-shadow: 0 4px 6px 0; border-radius: 5px">
                                <thead>
                                <tr>
                                    <th class="d-none d-sm-table-cell">#</th>
                                    <th>{{ $t('product.title') }}</th>
                                    <th>{{ $t('amount') }}</th>
                                    <th class="d-none d-sm-table-cell">{{ $t('price') }}</th>
                                    <th>{{ $t('sale.sum') }}</th>
                                </tr>
                                </thead>
                                <tbody
                                    v-for="(saleProduct, index) in item.saleProducts"
                                    :key="saleProduct.id"
                                >
                                <tr>
                                    <td class="d-none d-sm-table-cell">
                                        {{ index + 1 }}
                                    </td>
                                    <td> {{ saleProduct.product.name }}</td>
                                    <td>
                                        {{
                                            parseFloat(saleProduct.amount) + ' ' + showUnitOfMeasure(saleProduct.product.unitOfMeasure)
                                        }}
                                    </td>
                                    <td class="d-none d-sm-table-cell">
                                        {{ showCurrencyById(item.currency.id, saleProduct.price) }}
                                    </td>
                                    <td>{{
                                            showCurrencyById(item.currency.id, saleProduct.price * saleProduct.amount)
                                        }}
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </Row>
                        <Row
                            type="form-row"
                            class="col-sm-10 m-0 pt-2 my-2 justify-content-end"
                        >
                            <div class="col-12 col-lg-4 mb-3 mb-lg-0" v-if="item.description !== null">
                                <span class="text-uppercase font-weight-bold">
                                   {{ $t('additionalInformation') }}
                                </span>
                                <span
                                    class="d-block"
                                    style="border: 1px solid; border-radius: 3px"
                                >
                                    {{ item.description }}
                                </span>
                            </div>
                            <div class="col-12 col-lg-8">
                                <div
                                    class=" col-12 table-bordered text-uppercase font-weight-bold d-flex "
                                    style="color: #081EE8; border-radius: 5px"
                                >
                                    <div class="col-6">
                                        <h5>{{ $t('printView.totalSum') }}</h5>
                                    </div>
                                    <div class="col-6">
                                        <h5 class="float-right">{{
                                                showCurrencyById(item.currency.id, item.totalPrice)
                                            }}</h5>
                                    </div>
                                </div>

                                <div
                                    class="col-12 table-bordered font-weight-bold d-flex"
                                    style="color: #14F00F"
                                >
                                    <div class="col-6">
                                        <h5>{{ $t('payed') }}</h5>
                                    </div>
                                    <div class="col-6">
                                        <h5 class="float-right"> {{
                                                showCurrencyById(item.currency.id, item.payedAmount)
                                            }}</h5>
                                    </div>
                                </div>

                                <div
                                    class="col-12 table-bordered font-weight-bold d-flex"
                                    style="color: #E30000"
                                >
                                    <div class="col-6">
                                        <h5>{{ $t('debt') }}</h5>
                                    </div>
                                    <div class="col-6">
                                        <h5 class="float-right">{{
                                                showCurrencyById(item.currency.id, item.totalPrice - item.payedAmount)
                                            }}</h5>
                                    </div>
                                </div>
                            </div>
                        </Row>
                    </td>
                </tr>
                </tbody>
            </table>
            <Row class="col-12 ml-lg-5">
                <div
                    class="col-12 col-lg-10 table-bordered text-uppercase font-weight-bold d-flex "
                    style="color: #081EE8"
                >
                <span class="col-6 float-left">
                    <h5>{{ $t('printView.totalSum') }}</h5>
                </span>
                    <span class="col-6 float-right">
                    <h5 class="float-right">{{ showCurrencyById(baseCurrencyId, getDebt.totalSum) }}</h5>
                </span>
                </div>

                <div
                    class="col-12 col-lg-10 table-bordered font-weight-bold d-flex"
                    style="color: #14F00F"
                >
                <span class="col-6 float-left">
                    <h5>{{ $t('payed') }}</h5>
                </span>
                    <span class="col-6 float-right">
                    <h5 class="float-right">{{ showCurrencyById(baseCurrencyId, getDebt.totalPayment) }}</h5>
                </span>
                </div>

                <div
                    class="col-12 col-lg-10 table-bordered font-weight-bold d-flex"
                    style="color: #E30000"
                >
                <span class="col-6 float-left">
                    <h5>{{ $t('debt') }}</h5>
                </span>
                    <span class="col-6">
                    <h5 class="float-right">{{ showCurrencyById(baseCurrencyId, totalDebt) }}</h5>
                </span>
                </div>
            </Row>
        </b-modal>

        <div class="row container pt-4">
            <div class="col-6">
                <div class="person">
                    <font-awesome-icon
                        v-if="!this.getCustomer.isCompany"
                        class="text-main"
                        :icon="['fa', 'user-tie']"
                        size="1x"
                    />
                    <font-awesome-icon
                        v-if="getCustomer.isCompany"
                        class="text-main"
                        :icon="['fa', 'building']"
                        size="1x"
                    />
                    <span class="text-gray-500 font-bold">
                    {{ getCustomerName(getCustomer) }}
                    </span>
                </div>
                <div v-if="getCustomer.createdAt !== null">
                    {{ $t('customer.dateAdd') + ': ' + dateTimeFormat(getCustomer.createdAt) }}
                </div>
            </div>
            <div class="col-6">
                <Column v-if="canSeeCustomerDebts() && sumDebt > 0">
                    <LabelTag class="d-flex" style="margin-bottom: 2px">
                        <div v-if="canManagerSuppliers()" class="h-25 ml-1 mr-1">
                            {{ $t('debt') }}:
                        </div>&nbsp;&nbsp;
                        <div v-if="canManagerSuppliers()" class="d-flex text-danger h-25 ml-1">
                            <div>
                                <strong style="cursor: pointer"
                                        @click="sumDebt > 0 ? $bvModal.show('my-modal-data') : ''">{{
                                        numberWithCommas(this.sumDebt)
                                    }}</strong>
                            </div>
                            <b-form-select v-if="sumDebt > 0" class="col-8 mx-3 mt-n2"
                                           style="font-weight: bold; padding: 0; border: none"
                                           v-model="currentCurrencyShortName">
                                <b-form-select-option value="UZS">UZS</b-form-select-option>
                                <b-form-select-option value="USD">USD</b-form-select-option>
                                <b-form-select-option value="RUB">RUB</b-form-select-option>
                            </b-form-select>
                        </div>
                    </LabelTag>
                    <div class="d-flex" v-if="sumDebt > 0">
                        <div class="d-flex col-9 form-control px-1 py-1">
                            <input
                                class="col-8"
                                style="border: none; outline: none;"
                                v-model="payDebt"
                                type="number"
                                min="0"
                                @input="changeInput"
                            />
                            <b-button
                                size="md"
                                style="padding: 0; height: 30px; width: 100px; background-color: #6f42c1"
                                type="submit"
                                class="btn col-4"
                                :disabled="isMore"
                                v-on:click.prevent="$bvModal.show('pay-modal'); payDebt = sumDebt"
                            >
                                    <span v-show="isLoading" class="spinner-border spinner-border-sm" role="status"
                                          aria-hidden="true"></span>
                                {{ $t('filter.all') }}
                            </b-button>
                        </div>
                        <button
                            type="submit"
                            class="form-control btn col-3 ml-1 text-white"
                            style="background-color: #17A2B8"
                            :disabled="isLoading && !isMore"
                            v-on:click.prevent="$bvModal.show('pay-modal')"
                        >
                                    <span v-show="isLoading" class="spinner-border spinner-border-sm" role="status"
                                          aria-hidden="true"></span>
                            {{ $t('pay') }}
                        </button>
                    </div>
                    <span v-if="isMore" class="pl-3" style="color: red">
                                {{ $t('errorData') }}
                            </span>
                </Column>
            </div>
        </div>

        <Row class="container text-gray-500 font-bold">
            <div v-if="getCustomerTelephone(getCustomer) !== null" class="col-12">
                <div>{{ $t('person.telephone') + ': ' + getCustomerTelephone(getCustomer) }}</div>
            </div>
            <div v-if="getCustomer.email !== null" class="col-12">
                <div>{{ $t('user.email') + ': ' + getCustomer.email }}</div>
            </div>
            <div v-if="getCustomer.hasCard" class="col-6">
                <div>{{ $t('customer.opportunities') }}</div>
                <div class="d-flex justify-content-between">
                    <div class="percent-discount">
                        {{ $t('customer.discountPercent') + ' ' + getCustomer.cashbackCard.percent }}%
                    </div>
                </div>
            </div>
        </Row>

        <HrRow/>

        <div v-if="getCustomer.hasCard" class="container grid grid-cols-12 gap-3">
            <div class="col-span-4">
                <div class="my-card card" style="background-color: #8300C5">
                    <div>{{ $t('customer.totalSalesAmount') }}</div>
                    <div>
                        {{
                            showCurrencyById(getCurrencyByShortName(currentCurrencyShortName).id, getCustomerSalesTotalAmount[0])
                        }}
                    </div>
                </div>
            </div>
            <div class="col-span-4">
                <div class="my-card card" style="background-color: #04C100">
                    <div>{{ $t('customer.cashback.amount') }}</div>
                    <div>
                        {{
                            showCurrencyById(getCustomer.cashbackCard.currency.id, getCustomer.cashbackCard.cashbackAmount)
                        }}
                    </div>
                </div>
            </div>
            <div class="col-span-4">
                <div class="my-card card" style="background-color: #4BA9FF">
                    <div>{{ $t('customer.cashback.totalAmount') }}</div>
                    <div>
                        {{
                            showCurrencyById(getCustomer.cashbackCard.currency.id, getCustomer.cashbackCard.totalCashbackAmount)
                        }}
                    </div>
                </div>
            </div>
        </div>

        <HrRow v-if="getCustomer.hasCard" />

        <div class="container pb-4">
            <RowColumn v-if="paymentDebtHistories.length > 0" class="text-right float-left mb-4">
                <b-button
                    variant="primary"
                    @click="showOrHideDebtHistories"
                >
                    <span> {{ $t('productPurchase.paymentHistory') }}</span>
                    <span v-if="hasDebtHistories">&#9650;</span> <span v-else>&#9660;</span>
                </b-button>
            </RowColumn>

            <RowColumn class="text-right">
                <b-button
                    variant="primary"
                    @click="showOrHideSalesHistory"
                >
                    <span> {{ $t('sale.purchaseHistory') }}</span>
                    <span v-if="hasSalesCustomer">&#9650;</span> <span v-else>&#9660;</span>
                </b-button>
            </RowColumn>
        </div>
        <div class="container pb-4">
            <template v-if="hasDebtHistories" class="col-12 m-0 pt-0 ml-5">
                <div class="col-span-12 grid sm:grid-cols-2 md:grid-cols-2 gap-3 py-3">
                    <div class="position-relative">
                        <div class="font-bold text-sm bg-white px-1 text-fontColor z-30 position-absolute -top-2 ml-2">
                            {{ $t('filter.thisTime') }}
                        </div>
                        <input
                            class="px-0 border border-gray-300 h-11 rounded w-full focus:ring-0"
                            v-model="searchDebtHistory.after"
                            type="date"
                            @input="searchSalesInfo"
                        />
                    </div>

                    <div class="position-relative">
                        <div class="font-bold text-sm bg-white px-1 text-fontColor z-30 position-absolute -top-2 ml-2">
                            {{ $t('filter.toTime') }}
                        </div>
                        <input
                            class="px-0 border border-gray-300 h-11 rounded w-full focus:ring-0"
                            v-model="searchDebtHistory.before"
                            type="date"
                            @input="searchSalesInfo"
                        />
                    </div>
                </div>
                <table class="table">
                    <thead>
                    <tr>
                        <th>{{ $t('productPurchase.paymentAmount') }}</th>
                        <th>{{ $t('date') }}</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(debtHistory, index) in getCustomerDebtHistory"
                        v-bind:key="index">
                        <td>{{ showCurrencyById(debtHistory.sale.currency.id, debtHistory.payment) }}</td>
                        <td>{{ dateTimeFormat(debtHistory.createdAt) }}</td>
                    </tr>
                    </tbody>
                </table>

                <RowColumn>
                    <Pagination
                        method-name="fetchDebtFilter"
                        :total-items="getCustomerDebtTotalAmount"
                        :search="searchDebtHistory"
                        :base-url="'customer/view/' + searchDebtHistory.customerId"
                    />
                </RowColumn>

            </template>

            <template v-if="hasSalesCustomer">
                <div v-for="sale in getSales" :key="sale.id">
                    <div class="card mt-4" :style="`background-color: ${bgColor(sale)}`">
                        <div class="row pl-3 pt-1">
                            <div class="col font-weight-bold">
                                {{ $t('sale.title') }} # {{ sale.id }}
                            </div>
                        </div>

                        <div class="row align-items-center px-5 mb-4">
                            <div class="col-md-6 col-sm-12">
                                <div class="d-flex justify-content-between">
                                    <div>{{ $t('totalPrice') }}</div>
                                    <div style="color: #00AD30">{{
                                            showCurrencyById(sale.currency.id, sale.totalPrice)
                                        }}
                                    </div>
                                </div>
                                <div class="d-flex justify-content-between">
                                    <div>{{ $t('employee.cashier') }}</div>
                                    <div style="color: #00AD30">{{ getEmployeeName(sale) }}</div>
                                </div>
                                <div class="d-flex justify-content-between">
                                    <div>{{ $t('date') }}</div>
                                    <div style="color: #00AD30">{{ dateTimeFormat(sale.createdAt) }}</div>
                                </div>
                            </div>
                            <div class="col-md-6 col-sm-12">
                                <div class="d-flex justify-content-between">
                                    <div>{{ $t('incomeAndOutcome.Status') }}</div>
                                    <div style="color: #00AD30">{{ hasPayedText(sale) }}</div>
                                </div>
                                <div class="d-flex justify-content-between">
                                    <div>{{ $t('payed') }}</div>
                                    <div style="color: #00AD30">{{
                                            showCurrencyById(sale.currency.id, sale.cash)
                                        }}
                                    </div>
                                </div>
                                <div class="d-flex justify-content-between">
                                    <div :style="`color: ${sale.debt > 0 ? '#AD0000' : ''}`">{{ $t('debt') }}</div>
                                    <div :style="`color: ${debtColor(sale)}`">
                                        {{ showCurrencyById(sale.currency.id, sale.debt) }}
                                    </div>
                                </div>
                                <div class="d-flex justify-content-between">
                                    <div>{{ $t('payType') }}</div>
                                    <div style="color: #00AD30">{{ showPayType(sale) }}</div>
                                </div>
                            </div>
                        </div>

                        <div class="card" style="height: 45px">
                            <div class="col btn-products">
                                <div @click="saleId = sale.id">
                                    <ins>• {{ $t('product.title2') }}</ins>
                                </div>
                            </div>
                        </div>
                    </div>
                    <RowColumn sm-size="10">
                        <table class="card table mt-4" v-if="saleId === sale.id">
                            <thead>
                            <th>#</th>
                            <th class="col-3 p-3"> {{ $t('product.name') }}</th>
                            <th class="col-3 p-3"> {{ $t('price') }}</th>
                            <th class="col-3 p-3"> {{ $t('amount') }}</th>
                            <th class="col-3 p-3"> {{ $t('sale.sum') }}</th>
                            </thead>
                            <tbody v-for="saleProduct in sale.saleProducts" :key="saleProduct.id">
                            <td>{{ saleProduct.product.id }}</td>
                            <td class="col-3 p-3">{{ saleProduct.product.name }}</td>
                            <td class="col-3 p-3">
                                {{ showCurrencyById(sale.currency.id, saleProduct.product.sellingPrice) }}
                            </td>
                            <td class="col-3 p-3"> {{ parseInt(saleProduct.amount) }}
                                {{ showUnitOfMeasure(saleProduct.product.unitOfMeasure) }}
                            </td>
                            <td class="col-3 p-3">
                                {{
                                    showCurrencyById(sale.currency.id, saleProduct.product.sellingPrice * saleProduct.amount)
                                }}
                            </td>
                            </tbody>
                        </table>
                    </RowColumn>
                </div>

                <RowColumn>
                    <Pagination
                        method-name="fetchSalesCustomer"
                        :total-items="getSalesTotalCount"
                        :search="search"
                        :base-url="'customersId/' + search.customerId "
                    />
                </RowColumn>
            </template>
        </div>
    </Row>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import validatorMixin from "../../mixin/validatorMixin";
import accessMixin from "../../mixin/accessMixin";
import currencyFormatMixin from "../../mixin/currencyFormatMixin";
import dateFormattingMixin from "@/mixin/dateFormattingMixin";
import currencyRateMixin from "@/mixin/currencyRateMixin";
import Row from "../../components/html/Row.vue";
import Column from "../../components/html/Column.vue";
import LabelTag from "../../components/html/LabelTag.vue";
import HrRow from "../../components/html/HrRow.vue";
import RowColumn from "../../components/RowColumn.vue";
import Pagination from "../../components/html/Pagination.vue";

export default {
    name: "ViewPage",
    components: {
        Pagination,
        RowColumn,
        HrRow,
        LabelTag, Column,
        Row,
    },
    mixins: [validatorMixin, accessMixin, currencyFormatMixin, dateFormattingMixin, currencyRateMixin],
    data() {
        return {
            saleId: null,
            hasSalesCustomer: false,
            hasDebtHistories: false,
            color: '#FFEEBA',
            search: {
                customerId: this.$route.params.id,
                isPayed: null,
                after: '',
                before: '',
                totalPriceMin: '',
                totalPriceMax: '',
                page: this.$route.params.page
            },
            searchDebtHistory: {
                customerId: this.$route.params.id,
                after: '',
                before: '',
                page: 1
            },
            options: [
                {text: this.$t('filter.all'), value: null},
                {text: this.$t('payed'), value: true},
                {text: this.$t('onCredit'), value: false}
            ],
            submitButtonName: 'add',
            modalText: '',
            isLoading: false,
            breadcrumbItems: [
                {name: 'home', url: ''},
                {name: 'customer.title'},
            ],
            errors: {
                companyName: null,
                companyTelephone: null,
                givenName: null,
                personFamilyName: null,
                personGender: null,
                personTelephone: null,
                debt: null,
                currencyId: null,
            },
            modelForm: {
                id: null,
                isCompany: true,
                companyName: '',
                companyTelephone: '',
                givenName: '',
                familyName: '',
                gender: 1,
                telephone: '',
                debt: '',
                currencyId: 0,
            },
            customerDebt: 0,
            customerName: '',
            payDebt: null,
            totalDebt: 0,
            sumDebt: 0,
            paymentDebtHistories: [],
            isMore: false
        }
    },
    computed: {
        ...mapGetters([
            'getCustomer',
            'getDebt',
            'getUserCompanyId',
            'getCurrencyByShortName',
            'getSales',
            'getSalesTotalCount',
            'getCustomerSalesTotalAmount',
            'getCustomerDebtHistory',
            'getCustomerDebtTotalAmount'
        ]),
        errorsCompany() {
            return {
                companyName: this.errors.companyName,
            }
        },
        errorsPerson() {
            return {
                givenName: this.errors.givenName,
            }
        },

    },
    methods: {
        ...mapActions([
            'putCustomer',
            'pushCustomer',
            'fetchCustomer',
            'fetchUser',
            'fetchCompany',
            'fetchDebt',
            'payToCustomer',
            'fetchSalesCustomer',
            'searchSales',
            'fetchCustomerSalesTotalAmount',
            'setBreadcrumbItems',
            'fetchDebtFilter'
        ]),
        showPayType(sale) {
            if (sale.cash > 0) {
                return this.$t('statistics.categories.cash')
            } else if (sale.bankCard > 0) {
                return this.$t('statistics.categories.bankCard')
            } else {
                return this.$t('statistics.categories.moneyTransfer')
            }
        },
        textSplice(text) {
            if (text !== null) {
                if (text.length > 20) {
                    return text.slice(0, 20) + ' . . .'
                }
                return text
            }

            return "-"
        },
        hasNotPayed(item) {
            return item.transaction === null
        },
        hasNotPayedCanceled(item) {
            return item.isCanceled === true
        },
        hasPayedText(item) {
            if (this.hasNotPayedCanceled(item)) {
                return this.hasNotPayedCanceled(item) ? this.$t('sale.transaction.canceled') : this.$t('payed')
            }

            return this.hasNotPayed(item) ? this.$t('statistics.categories.debt') : this.$t('payed')
        },
        getCustomerName(customer) {
            if (customer.id) {
                return customer.isCompany ?
                    customer.customerCompany.name :
                    customer.person.givenName + ' ' + customer.person.familyName
            }
        },
        getCustomerTelephone(customer) {
            if (customer.id) {
                return customer.isCompany ?
                    customer.customerCompany.telephone :
                    customer.person.telephone
            }
        },
        getEmployeeName(item) {
            return item.employee.givenName
        },
        changeInput() {
            this.isMore = parseInt(this.payDebt) > parseInt(this.sumDebt);
        },
        goToDetails(id) {
            this.$i18nHelper.toUrl('sales/transactions/' + id)
        },
        showOrHideSalesHistory() {
            this.hasSalesCustomer = !this.hasSalesCustomer
        },
        showOrHideDebtHistories() {
            if (this.hasSalesCustomer) {
                this.hasSalesCustomer = !this.hasSalesCustomer
            }
            this.hasDebtHistories = !this.hasDebtHistories
        },
        resetSaleSearchInfo() {
            Object.assign(this.$data, this.$options.data.call(this));
            this.searchSalesInfo()
        },
        backgroundColor(amount) {
            if (amount > 0) {
                return this.color
            }
        },
        searchSalesInfo() {
            this.$root.showOverlay = true
            this.search.page = 1

            this.fetchDebtFilter(this.searchDebtHistory)
                .catch((err) => {
                    console.log(err)
                })
                .finally(() => {
                    this.$root.showOverlay = false
                });
        },
        payDebts() {
            this.$bvModal.hide('pay-modal')
            this.$root.showOverlay = true

            this.payToCustomer({
                id: this.$route.params.id,
                paymentAmount: parseFloat(this.payDebt),
                currency: this.getCurrencyByShortName(this.currentCurrencyShortName)['@id']
            })
                .then(() => {
                    this.findCustomer()
                    this.payDebt = null
                    this.$root.showOverlay = false
                })
        },
        numberWithCommas(x) {
            return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        },
        addOrEdit() {
            if (this.$route.name === 'customers/add') {
                this.isLoading = true

                if (this.modelForm.isCompany) {
                    this.pushCustomer({
                        isCompany: this.modelForm.isCompany,
                        companyName: this.modelForm.companyName,
                        companyTelephone: this.modelForm.companyTelephone,
                        debt: this.modelForm.debt,
                        currency: '/api/currencies/' + this.modelForm.currencyId,
                    })
                        .then(() => {
                            this.$i18nHelper.toUrl('customers')
                        })
                        .catch((reason) => {
                            if (reason === 'You have not available credits') {
                                this.modalText = this.$t('error.overLimit')
                                this.$bvModal.show('modal_show')
                            } else {
                                this.modalText = reason
                                this.$bvModal.show('modal_show')
                            }
                        })
                } else {
                    this.pushCustomer({
                        isCompany: this.modelForm.isCompany,
                        personGivenName: this.modelForm.givenName,
                        personFamilyName: this.modelForm.familyName,
                        personGender: this.modelForm.gender,
                        personTelephone: this.modelForm.telephone,
                        debt: this.modelForm.debt,
                        currency: '/api/currencies/' + this.modelForm.currencyId,
                    })
                        .then(() => {
                            this.$i18nHelper.toUrl('customers')
                        })
                        .catch((reason) => {
                            this.modalText = reason
                            this.$bvModal.show('modal_show')
                        })
                }
                setTimeout(() => {
                    this.isLoading = false
                }, 5000)
            } else {
                this.isLoading = true
                if (this.modelForm.isCompany) {
                    this.putCustomer({
                        url: 'customer_companies',
                        id: this.modelForm.id,
                        name: this.modelForm.companyName,
                        telephone: this.modelForm.companyTelephone,
                    })
                        .then(() => {
                            this.$i18nHelper.toUrl('customers')
                        })
                        .catch((reason) => {
                            this.modalText = reason
                            this.$bvModal.show('modal_show')
                        })
                } else {
                    this.putCustomer({
                        url: 'people',
                        id: this.modelForm.id,
                        givenName: this.modelForm.givenName,
                        familyName: this.modelForm.familyName,
                        gender: this.modelForm.gender,
                        telephone: this.modelForm.telephone
                    })
                        .then(response => {
                            console.log(response['@id'])
                            this.$i18nHelper.toUrl('customers')
                        })
                        .catch((reason) => {
                            this.modalText = reason
                            this.$bvModal.show('modal_show')
                        })
                }

                this.putCustomer({
                    url: 'customers',
                    id: this.$route.params.id,
                    debt: (Number(this.modelForm.debt) + Number(this.getCustomer.debt)).toString(),
                    currency: '/api/currencies/' + this.modelForm.currencyId,
                })
                    .then(() => {
                        this.$i18nHelper.toUrl('customers')
                    })
                    .catch((reason) => {
                        this.modalText = reason
                        this.$bvModal.show('modal_show')
                    })

                setTimeout(() => {
                    this.isLoading = false
                }, 5000)
            }
        },
        debtColor(sale) {
            return sale.debt > 0 ? '#AD0000' : '#00AD30'
        },
        bgColor(sale) {
            return sale.debt > 0 ? '#fffcbe' : ''
        },
        findCustomer() {
            if (this.canSeeCustomerDebts()) {
                this.fetchCustomerSalesTotalAmount(this.$route.params.id)
                this.fetchDebt(this.$route.params.id)
                    .then(() => {
                        this.paymentDebtHistories = this.getDebt.debtsPaymentHistory
                        this.sumDebt = parseFloat(this.getDebt.customerDebt)
                        this.totalDebt = this.getDebt.customerDebt
                    })
            }

            this.fetchCustomer(this.$route.params.id)
                .then(() => {
                    this.fetchCustomerSalesTotalAmount(this.getCustomer.id)
                })
                .finally(() => {
                    this.customerName = this.getCustomerName(this.getCustomer)

                    if (!this.getCustomer.isCompany) {
                        this.modelForm.isCompany = false
                        this.modelForm.id = this.getCustomer.person.id
                        this.modelForm.givenName = this.getCustomer.person.givenName
                        this.modelForm.familyName = this.getCustomer.person.familyName
                        this.modelForm.telephone = this.getCustomer.person.telephone ? this.getCustomer.person.telephone : ''
                        this.modelForm.gender = this.getCustomer.person.gender
                    } else {
                        this.modelForm.id = this.getCustomer.customerCompany.id
                        this.modelForm.companyName = this.customerName
                        this.modelForm.companyTelephone = this.getCustomer.customerCompany.telephone ? this.getCustomer.customerCompany.telephone : ''
                    }

                    this.$root.showOverlay = false
                })
        }
    },
    watch: {
        'currentCurrencyShortName'(newVal, oldVal) {
            this.sumDebt = this.calculateAmountByBaseCurrency(this.sumDebt, oldVal, newVal)
        }
    },
    created() {
        this.setBreadcrumbItems(this.breadcrumbItems)
    },
    mounted() {
        this.findCustomer()
    },
}
</script>
<style scoped>
.percent-discount {
    width: 172px;
    height: 33px;
    background: #4BA9FF;
    color: #FFFFFF;
    border-radius: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
}

.person {
    color: #1E79BB;
    font-size: 30px;
}

.my-card {
    height: 150px;
    color: #FFFFFF;
    border-radius: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
}

.btn-products {
    background-color: #B0B0B0;
    color: #00AF90;
    font-size: 25px;
    cursor: pointer;
}

</style>
